import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TelerikReportViewerComponent } from '@progress/telerik-angular-report-viewer';
import { AuthService } from '../../services/auth.service';
import { AzureMapsService } from '../../services/azure-maps.service';
import { CarrierTenderService } from '../../services/carrier-tender.service';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { EmailService } from '../../services/email.service';
import { ERPService } from '../../services/erp.service';
import { FileService } from '../../services/file.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    TravelEstimate,
    City,
    Contact,
    MacropointData,
    MacropointLocationProvider,
    MacropointTrackingOption,
    OrderEventType,
    PostTenderData,
    SearchCarrierContact,
    SearchOrderEventType,
    StopData,
    TenderData
} from '../../models/models';

//const httpOptions = {
//    headers: new HttpHeaders({
//        'Content-Type': 'application/json'
//    })
//};

@Component({
    selector: 'carrier-tender',
    templateUrl: './carrier-tender.component.html',
    standalone: false
})
export class CarrierTenderComponent implements OnInit, AfterViewInit {
    @ViewChild(TelerikReportViewerComponent, { static: false }) viewer1: TelerikReportViewerComponent | undefined;
    public encryptedOrder: string = '';
    //public driverOneFilter: string = '';
    //public driverTwoFilter: string = '';
    public tenderData: TenderData;
    public savedData: PostTenderData = {} as PostTenderData;
    public macropointData: MacropointData = {} as MacropointData;
    public stopData: StopData;
    private firstStopCity: City = {} as City;
    public travelEstimate: TravelEstimate = {} as TravelEstimate;
    //public picker: Date = new Date();
    public beginTrackingDate: Date = new Date();
    public endTrackingDate: Date = new Date();
    //public prePickupDate: Date = new Date;
    //public filteredDriverOnes: Observable<string[]> = new Observable<string[]>();
    //public filteredDriverTwos: Observable<string[]> = new Observable<string[]>();
    public cityControl = new UntypedFormControl();
    //public prePickupCityControl = new UntypedFormControl();
    //public driverOneControl = new FormControl();
    //public driverTwoControl = new FormControl();
    public pickupCity: City[] = new Array();
    public ppcCity: City = {} as City;
    public defaultCity: string = "";
    public defaultPrePickupCity: string = "";
    //public contacts: Contact[] = [];
    //public drivers: Contact[] = [];
    public carrierContacts: SearchCarrierContact[] = [];
    public contacts: SearchCarrierContact[] = [];
    public drivers: SearchCarrierContact[] = [];
    public selectedContact: SearchCarrierContact = {} as SearchCarrierContact;
    public selectedDriver: SearchCarrierContact = {} as SearchCarrierContact;
    public selectedDriver2: SearchCarrierContact = {} as SearchCarrierContact;
    public isAddDispatcher: boolean = false;
    public isAddDriver1: boolean = false;
    public isAddDriver2: boolean = false;
    public isEditDispatcher: boolean = false;
    public isEditDriver1: boolean = false;
    public isEditDriver2: boolean = false;

    public orderEventTypes: OrderEventType[] = [];
    public searchOrderEventTypes: SearchOrderEventType[] = [];
    //public locationProviders: MacropointLocationProvider[] = [];
    //public trackingOptions: MacropointTrackingOption[] = [];
    //public filteredTrackingOptions: MacropointTrackingOption[] = [];
    //public selectedTrackingOption: MacropointTrackingOption = {} as MacropointTrackingOption;
    //public defaultProvider: MacropointLocationProvider = {} as MacropointLocationProvider;

    public macropointLocationProviders: MacropointLocationProvider[] = [];
    public macropointTrackingOptionsAll: MacropointTrackingOption[] = [];
    public macropointTrackingOptions: MacropointTrackingOption[] = [];
    public macropointLocationProviderId: number = 0;
    public macropointLocationProviderDevice: string = "";
    public macropointTrackingInterval: number = 0;
    //public providerId: number = 0;
    //public trackingId: number = 0;
    public pickupCityId: number = 0;
    public pickupIsDisabled: boolean = true;
    public pickupArrivalHour: number = 0;
    public pickupArrivalMinute: number = 0;
    public hasPickup: boolean = false;
    public isValid: boolean = true;
    public validationWarningList: string[] = [];
    //public isAddPrePickup: boolean = false;
    public isPickupStopDateValid: boolean = true;
    public carrierIsLate: boolean = false;
    public carrierBreaks: number = 0;
    public carrierBreakHours: number = 0;
    public saveMessage: string = "";
    public trackingNumber: string = "";
    //private http: HttpClient;
    private baseUrl: string = "";
    public macropointEmails: string = "";
    public reportUrl: string = "";
    public isDocViewer: boolean = false;
    public docViewerFileName: string = "";
    public docViewerFileUri: string = ""
    public printVisible: boolean = true;
    public countryCode: string = "US";
    //public mask: string = "(999) 000-0000";
    public phoneMask: string = "(999) 000-0000";
    public maxPickupDate: Date = new Date();
    public rateConMessage: string = '';
    public formValidator = {
        'dispatcher': false,
        'city': false,
        'driver1Name': false,
        'driver1Cell': false,
        'driver2Name': false,
        'driver2Cell': false,
        'truckNumber': false,
        'trailerNumber': false,
        'providerId': false,
        'trackingId': false,
        'pickupDate': false
    };
    carrierTenderFormGroup: UntypedFormGroup = new UntypedFormGroup({
        cityControl: new UntypedFormControl('')
    });
    viewerContainerStyle = {
        position: 'relative',
        width: '1000px',
        height: '800px',
        ['font-family']: 'ms sans serif',
        ['font-size']: '25px'
    };

    constructor(private fb: UntypedFormBuilder,
        //http: HttpClient,
        @Inject('BASE_URL') baseUrl: string,
        route: ActivatedRoute,
        public dialog: MatDialog,
        private titleService: Title,
        public authService: AuthService,
        private azureMapsService: AzureMapsService,
        private tenderService: CarrierTenderService,
        private cityService: CityService,
        private contactService: ContactService,
        private cseService: CSEService,
        private emailService: EmailService,
        private erpService: ERPService,
        private fileService: FileService,
        private notificationService: NotificationService,
        private orderService: OrderService,
        private utilService: UtilService) {
        this.titleService.setTitle('Carrier Tender');
        this.tenderData = {} as TenderData;
        this.stopData = { pickupStopDate: new Date() } as StopData;
        //this.http = http;
        this.baseUrl = baseUrl;
        //baseUrl = "https://epilutionswebportal-test.azurewebsites.net/";
        this.reportUrl = baseUrl + 'api/Reports/';
        route.params.subscribe(params => { this.encryptedOrder = params.orderNumber });

        this.tenderService.getTenderData(encodeURIComponent(this.encryptedOrder)).subscribe(result => {
            this.tenderData = result;
            this.titleService.setTitle('Carrier Tender #' + this.tenderData.orderNumber);
            this.getContacts();
            this.setReportSource();
            this.viewFile();
            this.printVisible = false;
            this.macropointLocationProviderId = this.tenderData.macropointLocationProviderId;
            this.getMacropointLocationProviders();
            //this.providerChanged(this.macropointLocationProviderId);
        }, error => console.error(error));

        this.orderService.getOrderEventTypes().subscribe(result => {
            this.orderEventTypes = result.resultCollection;
        });

        this.orderService.getGetAllSearchOrderEventType().subscribe(result => {
            this.searchOrderEventTypes = result;
        });
    }

    ngOnInit() {
        this.cityControl = new UntypedFormControl();
        this.pickupIsDisabled = true;
        this.isPickupStopDateValid = true;

        this.tenderService.getStopData(encodeURIComponent(this.encryptedOrder)).subscribe(result => {
            this.stopData = result;
            this.stopData.pickupStopDate = new Date(this.stopData.pickupStopDate);
            this.stopData.firstPickupDate = new Date(this.stopData.firstPickupDate);
            this.stopData.latestArrivalDate = new Date(this.stopData.latestArrivalDate);
            this.maxPickupDate = new Date(this.stopData.firstPickupDate.getTime() - 30 * 60000);

            this.hasPickup = this.stopData.pickupCityID > 0;
            if (this.hasPickup) {
                this.cityService.getCityByID(this.stopData.pickupCityID).subscribe(result2 => {
                    if (result2.resultCollection.length > 0) {
                        this.ppcCity = result2.resultCollection[0];
                        this.carrierTenderFormGroup.controls['cityControl'].setValue(this.ppcCity);
                        this.defaultCity = this.ppcCity.cityStateZip;
                    }
                    else {
                        this.hasPickup = false;
                        this.defaultCity = "";
                        this.ppcCity = {} as City;
                    }
                });
            }

            this.beginTrackingDate = new Date(this.stopData.pickupStopDate);
            this.beginTrackingDate.setTime(this.beginTrackingDate.getTime() - (2 * 60 * 60 * 1000));
            this.endTrackingDate = new Date(this.stopData.stops[this.stopData.stops.length - 1].latestDate);

            //if (this.authService.authenticated || !this.hasPickup) this.cityControl.enable(); 
            //if (!this.hasPickup) {
            if (this.authService.authenticated || !this.hasPickup) {
                this.pickupIsDisabled = false;
            }
            else {
                this.pickupIsDisabled = true;
            }

            this.cityService.getCityByID(this.stopData.stops[0].cityId).subscribe(result => {
                var cityList = result.resultCollection;
                if (cityList && cityList.length > 0) {
                    this.firstStopCity = cityList[0] as City;
                    this.defaultPrePickupCity = this.firstStopCity.cityStateZip;
                }
                else {
                    this.defaultPrePickupCity = "";
                }
            });
        }, error => console.error(error));
    }

    ngAfterViewInit() {
        //console.log('Values on ngAfterViewInit():');
    }

    private getContacts() {
        this.utilService.isLoading = true;
        this.contactService.getSearchContactByCarrierID(this.tenderData.carrierId).subscribe(result => {
            this.carrierContacts = result.resultCollection;
            this.contacts = this.carrierContacts.filter(c => c.contactTitleDesc.toLowerCase().trim() != "driver");
            this.drivers = this.carrierContacts.filter(c => c.contactTitleDesc.toLowerCase().trim() == "driver");
            this.initContacts();
            this.utilService.isLoading = false;
            //console.log("getContacts", this.contacts, this.drivers);
        });
    }

    private initContacts() {
        if (this.tenderData.carrierContactId != null) {
            this.selectedContact = this.contacts.find(c => c.contactID == this.tenderData.carrierContactId)! || {} as Contact;
        }
        if (this.tenderData.driverOneId!= null) {
            this.selectedDriver = this.drivers.find(c => c.contactID == this.tenderData.driverOneId)! || {} as Contact;
        }
        if (this.tenderData.driverTwoId != null) {
            this.selectedDriver2 = this.drivers.find(c => c.contactID == this.tenderData.driverTwoId)! || {} as Contact;
        }
        this.validate(true);
        //console.log("initContacts", this.selectedContact, this.selectedDriver, this.selectedDriver2);
    }

    public contactChange(evt: any) {
        //console.log("contactChange", evt.target.value, this.offer.quoteOrderLine.carrierContactId);
        var contactID = evt.target.value;
        if (contactID != "") {
            this.selectedContact = this.contacts.find(c => c.contactID == contactID)!;
            this.tenderData.carrierContactId = contactID;
            //this.offer.quoteOrderLine.carrierContactId = this.selectedContact.contactID;
            //this.tender.carrierContactId = this.selectedContact.contactID;
        }
        else {
            this.selectedContact = {} as SearchCarrierContact;
        }
        if (this.selectedContact.phone == undefined) {
            this.selectedContact.phone = "";
        }
        if (this.selectedContact.email == undefined) {
            this.selectedContact.email = "";
        }
        this.validate(true);
    }

    public addContact(contactType) {
        if (contactType == "Dispatcher") {
            this.isAddDispatcher = true;
        }
        if (contactType == "Driver1") {
            this.isAddDriver1 = true;
        }
        if (contactType == "Driver2") {
            this.isAddDriver2 = true;
        }
    }

    public editContact(contactType) {
        if (contactType == "Dispatcher") {
            this.isEditDispatcher = true;
        }
        if (contactType == "Driver1") {
            this.isEditDriver1 = true;
        }
        if (contactType == "Driver2") {
            this.isEditDriver2 = true;
        }
    }

    public refreshContacts(contactID: number, contactType: string) {
        if (contactType == "Dispatcher") {
            this.isAddDispatcher = false;
            this.isEditDispatcher = false;
            this.tenderData.carrierContactId = contactID;
        }
        else if (contactType == "Driver1") {
            this.isAddDriver1 = false;
            this.isEditDriver1 = false;
            this.tenderData.driverOneId = contactID;
        }
        else if (contactType == "Driver2") {
            this.isAddDriver2 = false;
            this.isEditDriver2 = false;
            this.tenderData.driverTwoId = contactID;
        }
        //console.log("refreshContacts", contactID, contactType);
        this.getContacts();
    }

    public driverChange(evt: any, num: number) {
        //console.log("driverChange", evt, evt.target.value, num);
        var contactID = evt.target.value;
        if (contactID != "") {
            if (num == 2) {
                this.selectedDriver2 = this.drivers.find(c => c.contactID == contactID)!;
                this.tenderData.driverTwoId = this.selectedDriver2.contactID;
            }
            else {
                this.selectedDriver = this.drivers.find(c => c.contactID == contactID)!;
                this.tenderData.driverOneId = this.selectedDriver.contactID;
            }
        }
        else {
            if (num == 2) {
                this.selectedDriver2 = {} as SearchCarrierContact;
            }
            else {
                this.selectedDriver = {} as SearchCarrierContact;
            }
        }
        if (this.selectedDriver.cell == undefined) {
            this.selectedDriver.cell = "";
        }
        if (this.selectedDriver2.cell == undefined) {
            this.selectedDriver2.cell = "";
        }
        this.validate(true);
    }

    private getMacropointLocationProviders() {
        this.orderService.getMacropointLocationProviders().subscribe(result => {
            this.macropointLocationProviders = result;
            this.getMacropointTrackingOptions();
        });
    }

    private getMacropointTrackingOptions() {
        this.orderService.getMacropointTrackingOptions().subscribe(result => {
            this.macropointTrackingOptionsAll = result;
            //this.macropointTrackingOptions = Object.assign([], this.macropointTrackingOptionsAll);
            var option = result.find(p => p.macropointTrackingOptionID == this.macropointLocationProviderId);
            this.filterMacropointLocationProvider(option!.locationProvider);
            this.getTrackVia();
        });
    }

    public macropointLocationProviderChange(evt: any) {
        //console.log("macropointLocationProviderChange", evt);
        var trackVia: MacropointLocationProvider | undefined;
        if (evt != null) {
            trackVia = this.macropointLocationProviders.find(t => t.macropointLocationProviderId == evt.target.value);
        }
        if (trackVia != null) {
            this.macropointLocationProviderDevice = trackVia.trackType;
            this.filterMacropointLocationProvider(trackVia!.provider);
        }
        //console.log("macropointLocationProviderChange", this.macropointLocationProviderDevice);
        this.validate(true);
    }

    private getTrackVia() {
        var trackVia: MacropointLocationProvider | undefined;
        trackVia = this.macropointLocationProviders.find(t => t.macropointLocationProviderId == this.macropointLocationProviderId);
        if (trackVia != null) {
            this.macropointLocationProviderDevice = trackVia.trackType;
            //this.filterMacropointLocationProvider(trackVia!.provider);
        }
        //console.log("getTrackVia", this.macropointLocationProviderDevice);
        this.validate(true);
    }

    private filterMacropointLocationProvider(provider: string) {
        var options: MacropointTrackingOption[] = [];
        if (provider == "") {
            options = Object.assign([], this.macropointTrackingOptionsAll);
        }
        else {
            options = this.macropointTrackingOptionsAll.filter(t => t.locationProvider == provider);
        }
        this.macropointTrackingOptions.length = 0;
        for (var i = 0; i < options.length; i++) {
            if (this.macropointTrackingOptions.findIndex(o => o.locationProvider == options[i].locationProvider && o.trackInterval == options[i].trackInterval && o.trackAmount == options[i].trackAmount) < 0) {
                this.macropointTrackingOptions.push(options[i]);
            }
        }
    }

    private validate(isMacropoint: boolean) {
        this.isValid = true;
        this.validationWarningList.length = 0;
        //var ppcCity = this.carrierTenderFormGroup.controls['cityControl'].value as City;
        if (this.selectedContact.email == null || this.selectedContact.email == "") {
            this.isValid = false;
            this.validationWarningList.push("Contact email required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "Mobile" && (this.selectedDriver.cell == null || this.selectedDriver.cell == "")) {
            this.isValid = false;
            this.validationWarningList.push("Driver Cell required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "VehicleID" && (this.tenderData.truckNumber == null || this.tenderData.truckNumber == "")) {
            this.isValid = false;
            this.validationWarningList.push("Truck # required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "TrailerID" && (this.tenderData.trailerNumber == null || this.tenderData.trailerNumber == "")) {
            this.isValid = false;
            this.validationWarningList.push("Trailer # required.");
        }
    }

    public acceptOffer() {
        //if (!this.isValid()) return;
        this.validate(true);
        if (!this.isValid) return;

        this.tenderData.accepted = true;
        this.saveTenderData(true);
    }

    public declineOffer() {
        this.openDeclineDialog();
    }

    private openDeclineDialog() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            width: '250px',
            data: {}
        }

        const dialogRef = this.dialog.open(DeclineDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.tenderData.accepted = false;
                this.saveTenderData(false);
            }
        });
    }

    public saveData() {
        //if (!this.isValid()) return;
        this.validate(true);
        if (!this.isValid) return;

        this.saveTenderData(this.tenderData.accepted);
    }

    private saveTenderData(accepted: boolean) {
        var offset = new Date().getTimezoneOffset();
        this.utilService.isLoading = true;
        this.pickupArrivalHour = this.stopData.pickupStopDate.getHours();
        this.pickupArrivalMinute = this.stopData.pickupStopDate.getMinutes();
        //var driverOne = this.driverOneControl.value;
        //var driverTwo = this.driverTwoControl.value;
        var driverOne: SearchCarrierContact = this.selectedDriver;
        var driverTwo: SearchCarrierContact = this.selectedDriver2;

        if (driverOne != null && typeof driverOne === 'string') {
            this.tenderData.driver1Cell = driverOne;
        }
        else {
            this.tenderData.driver1Cell = driverOne == null ? this.tenderData.driver1Cell : driverOne.cell;
            this.tenderData.driver1Name = driverOne == null ? this.tenderData.driver1Name : driverOne.contactName;
        }
        
        if (driverTwo != null && typeof driverTwo === 'string') {
            this.tenderData.driver2Cell = driverTwo;
        }
        else {
            this.tenderData.driver2Cell = driverTwo == null ? this.tenderData.driver2Cell : driverTwo.cell;
            this.tenderData.driver2Name = driverTwo == null ? this.tenderData.driver2Name : driverTwo.contactName;
        }

        this.savedData = {
            encryptedId: encodeURIComponent(this.encryptedOrder),
            //pickupCity: this.carrierTenderFormGroup.controls['cityControl'].value ? this.carrierTenderFormGroup.controls['cityControl'].value as City : null,
            pickupCityID: this.ppcCity.cityID,
            pickupArrivalDate: this.utilService.getDateAsUTC(this.stopData.pickupStopDate),
            pickupArrivalHours: this.pickupArrivalHour,
            pickupArrivalMinutes: this.pickupArrivalMinute,
            driver1Cell: this.tenderData.driver1Cell,
            driver1Name: this.tenderData.driver1Name,
            driver2Cell: this.tenderData.driver2Cell,
            driver2Name: this.tenderData.driver2Name,
            truckNumber: this.tenderData.truckNumber,
            trailerNumber: this.tenderData.trailerNumber,
            accepted: accepted,
            dispatcherName: this.tenderData.dispatcherName,
            verified: this.tenderData.verified,
            csrSaved: this.authService.authenticated,
            userTimeZone: offset,
            driverOneId: (driverOne == null || typeof driverOne == 'string') ? 0 : driverOne.contactID,
            driverTwoId: (driverTwo == null || typeof driverTwo == 'string') ? 0 : driverTwo.contactID,
            lastModifiedByEmployeeId: this.authService.authenticated ? parseInt(localStorage.getItem('EmployeeId')!) : -1,
            carrierContactId: this.tenderData.carrierContactId
        } as PostTenderData;

        this.tenderService.saveCarrierTender(this.savedData).subscribe(result => {
            this.utilService.isLoading = false;
            this.notificationService.showSuccess("Successfully saved tender.", "SUCCESS: Save Tender");
            this.saveMessage = result;
            this.clearMessage(this);
            //this.updateCSELoad();
            this.ngOnInit();
            return result;
        }, error => {
            this.utilService.isLoading = false;
            this.saveMessage = 'Failed to save';
            this.clearMessage(this);
            return false;
        });
    }

    private clearMessage(context: CarrierTenderComponent) {
        setTimeout(function () {
            context.saveMessage = '';
        }, 25000);
    }

    public print() {
        this.setReportSource();
        this.printVisible = true;
    }

    public hidePrint() {        
        this.printVisible = false;
    }

    public pickupCitySet(evt: any, isDefault: boolean) {
        var ppcCity = this.carrierTenderFormGroup.controls['cityControl'].value as City;
        //this.pickupCity[0] = ppcCity;
        this.ppcCity = ppcCity;
        if (ppcCity == null) return;
        this.getTravelEstimate();
    }

    public leavePickup() {
        this.getTravelEstimate();
    }

    public leaveDatePicker() {
        if (this.travelEstimate.miles == null || this.travelEstimate.miles < 1) {
            this.getTravelEstimate();
        } else {
            this.carrierIsLate = this.isPickupDepartLate();
        }

        if (this.stopData.pickupStopDate > this.maxPickupDate) {
            this.isPickupStopDateValid = false;
        }
        else {
            this.isPickupStopDateValid = true;
        }

        this.beginTrackingDate = new Date(this.stopData.pickupStopDate);
        this.beginTrackingDate.setTime(this.beginTrackingDate.getTime() - (2 * 60 * 60 * 1000));
        this.pickupArrivalHour = this.stopData.pickupStopDate.getHours();
        this.pickupArrivalMinute = this.stopData.pickupStopDate.getMinutes();
    }

    private getTravelEstimate() {
        var city = this.carrierTenderFormGroup.controls['cityControl'].value as City;

        if (!city || typeof city === 'string' || city instanceof String) return;


        this.azureMapsService.getTravelEstimateFromPickupStopByCityIdLineId(city.cityID, this.tenderData.quoteOrderLineId).subscribe(result => {
            this.travelEstimate = result;
            this.travelEstimate.arrivalDate = new Date(this.travelEstimate.arrivalDate);
            this.travelEstimate.departDate = new Date(this.travelEstimate.departDate);
            //this.stopData.pickupStopDate = this.travelEstimate.departDate;
            this.carrierIsLate = this.isPickupDepartLate();
            this.carrierBreaks = result.breaks;
            this.carrierBreakHours = result.breakHours;
        }, error => {
            var ok = 'fail';
        });
    }

    private isPickupDepartLate(): boolean {
        var pickupStop = new Date(this.stopData.pickupStopDate);
        var travelTimeHr: number = this.travelEstimate.miles / 50;
        pickupStop.setTime(pickupStop.getTime() + ((travelTimeHr + this.travelEstimate.breakHours) * 60 * 60 * 1000));
        return pickupStop > this.stopData.latestArrivalDate;
    }

    private setReportSource() {
        //var reportSource = this.viewer1!.getReportSource();
        //let params = reportSource.parameters;
        //params.QuoteOrderLineId = this.tenderData.quoteOrderLineId;
        //reportSource.parameters = params;
        //console.log("setReportSource", this.reportUrl, params, reportSource);
        //this.viewer1!.setReportSource(reportSource);
        ////this.viewer1!.refreshReport();
    }

    public saveMacropoint() {
        if (this.utilService.isLoading || this.macropointIsNotValid()) return;

        this.utilService.isLoading = true;
        var hours = Math.abs(this.beginTrackingDate.getTime() - this.endTrackingDate.getTime()) / 36e5;
        //var trackOption = this.trackingOptions.find(t => t.macropointTrackingOptionID == this.trackingId)!;
        //var provider = this.locationProviders.find(l => l.macropointLocationProviderId == this.macropointLocationProviderId)!;
        //var trackOption = this.macropointTrackingOptionsAll.find(t => t.macropointTrackingOptionID == this.trackingId)!;
        var trackOption = this.macropointTrackingOptionsAll.find(t => t.macropointTrackingOptionID == this.macropointTrackingInterval)!;
        var provider = this.macropointLocationProviders.find(l => l.macropointLocationProviderId == this.macropointLocationProviderId)!;

        this.macropointData = {
            quoteOrderLineId: this.tenderData.quoteOrderLineId,
            trackingNumber: this.trackingNumber,
            emails: this.macropointEmails,
            beginTracking: this.beginTrackingDate,
            endTracking: this.endTrackingDate,
            hoursToTrack: parseInt(hours.toString()),
            trackInterval: trackOption.trackInterval,
            notes: '',
            employeeID: parseInt(localStorage.getItem('EmployeeId')!),
            locationProvider: provider
        } as MacropointData;

        this.erpService.saveMacropointData(this.macropointData).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.message != "OK") {
                var err = result.message;
                return false;
            }
            else {
                this.macropointData = result.resultCollection[0];
            }
        });
    }

    private macropointIsNotValid(): boolean {
        var notValid = false;

        if (this.macropointLocationProviderId < 1) {
            this.formValidator.providerId = true;
            notValid = true;
            return notValid;
        }
        else {
            this.formValidator.providerId = false;
        }

        //var provider = this.locationProviders.find(p => p.macropointLocationProviderId == this.macropointLocationProviderId)!;
        var provider = this.macropointLocationProviders.find(p => p.macropointLocationProviderId == this.macropointLocationProviderId)!;

        switch (provider.trackType) {
            case 'Mobile':
                if (this.tenderData.driver1Cell == null || this.tenderData.driver1Cell.trim().length < 1) {
                    this.formValidator.driver1Cell = true;
                    notValid = true;
                } else {
                    this.trackingNumber = this.tenderData.driver1Cell;
                    this.formValidator.driver1Cell = false;
                }

                break;
            case 'VehicleID':
                if (this.tenderData.truckNumber == null || this.tenderData.truckNumber.trim().length < 1) {
                    this.formValidator.truckNumber = true;
                    notValid = false;
                } else {
                    this.trackingNumber = this.tenderData.truckNumber;
                    this.formValidator.truckNumber = false;
                }

                break;
            case 'TrailerID':
                if (this.tenderData.trailerNumber == null || this.tenderData.trailerNumber.trim().length < 1) {
                    this.formValidator.trailerNumber = true;
                    notValid = false;
                } else {
                    this.trackingNumber = this.tenderData.trailerNumber;
                    this.formValidator.trailerNumber = false;
                }

                break;
        }

        return notValid;
    }

    public sendRateConfirmation() {
        var contact = this.contacts.find(c => c.contactID == this.tenderData.carrierContactId);

        if (contact == null || contact.email.length < 1) {
            alert('Selected contact does not have an e-mail set.');
            return;
        }

        this.rateConMessage = '';
        let dialogRef = this.dialog.open(RateconConfirm, {
            width: '250px',
            data: {}
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (dialogResult) {
                this.emailService.sendRateConfirmation(this.tenderData.quoteOrderLineId).subscribe(result => {
                    if (result) {
                        this.rateConMessage = 'Successfully sent rate con report';
                    } else {
                        this.rateConMessage = 'Failed to send rate con report.  Please try again.  If it fails to send please contact your IT department.';
                    }
                });
            }
        });
    }

    public viewFile() {
        if (this.isDocViewer) {
            this.isDocViewer = false;
            this.docViewerFileName = "";
            this.docViewerFileUri = "";
        }
        else {
            this.isDocViewer = true;
            this.docViewerFileName = "RateConfirmation-" + this.tenderData.orderNumber + ".pdf";
            this.docViewerFileUri = this.fileService.downloadRateConfirmationPDF(this.tenderData.quoteOrderLineId);
            //this.docViewerFileUri = "https://localhost:44300/api/Files/DownloadRateConfirmationPDF/?quoteOrderLineID=779960";
            //this.docViewerFileUri = "https://epilutionswebportal-test.azurewebsites.net/api/Files/Download/?filename=CarrierFreightDetail-1684990-CarrierInvoice-19a4fc60701.pdf";
        }
        console.log("viewFile", this.docViewerFileName, this.docViewerFileUri);
    }

    public downloadFile() {
        window.open(this.fileService.downloadRateConfirmationPDF(this.tenderData.quoteOrderLineId), "_blank");
    }
}


@Component({
    selector: 'decline-dialog',
    templateUrl: './decline-dialog.component.html',
    styleUrls: ['./carrier-tender-decline-dialog.component.css'],
    standalone: false
})
export class DeclineDialog {

    constructor(
        public dialogRef: MatDialogRef<DeclineDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    confirmDecline(): void {
        this.dialogRef.close(true);
    }

    cancelDecline(): void {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'ratecon-confirm',
    templateUrl: './ratecon-confirm.component.html',
    styleUrls: ['./carrier-tender-ratecon-confirm-dialog.component.css'],
    standalone: false
})
export class RateconConfirm {

    constructor(
        public dialogRef: MatDialogRef<RateconConfirm>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }

    confirmRatecon(): void {
        this.dialogRef.close(true);
    }

    cancelRatecon(): void {
        this.dialogRef.close();
    }
}
